
export default {
  name: 'AImage',
  inheritAttrs: false,
  data: () => ({
    expanded: false,
    closeButtonRef: null,
  }),
  watch: {
    expanded(status) {
      this.$nextTick(() => {
        if (status) {
          this.cloned = this.$el.cloneNode(true);
          this.closeButtonRef = this.cloned.querySelector('.close-button');
          this.closeButtonRef.addEventListener('click', this.closeImage);
          document.body.appendChild(this.cloned);
          document.body.style.overflow = 'hidden';
          this.cloned.addEventListener('touchmove', this.freezeVp, false);
          setTimeout(() => {
            this.cloned.style.opacity = 1;
          }, 0);
        } else {
          this.cloned.style.opacity = 0;
          this.cloned.removeEventListener('touchmove', this.freezeVp, false);
          setTimeout(() => {
            this.closeButtonRef.removeEventListener('click', this.closeImage);
            this.cloned.remove();
            this.cloned = null;
            this.closeButtonRef = null;
            document.body.style.overflow = 'auto';
          }, 250);
        }
      });
    },
  },
  mounted() {
    // eslint-disable-next-line no-restricted-globals
    history.pushState(null, null, location.href);

    window.addEventListener('popstate', (e) => {
      if (this.expanded) {
        // eslint-disable-next-line no-restricted-globals
        history.pushState(null, null, location.href);
        this.expanded = false;
      }
      e.stopPropagation();
    });
  },
  beforeDestroy() {
    window.removeEventListener('popstate', () => {});
  },
  methods: {
    closeImage(event) {
      this.expanded = false;
      event.stopPropagation();
    },
    freezeVp(e) {
      e.preventDefault();
    },
  },
};
